import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { SIDE_MENU_ITEMS } from './constants/side-menu.constant';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';
import { DepartmentI } from '../../interfaces/department.interface';

@Component({
  selector: 'app-departments-details-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './departments-details-side-menu.component.html',
  styleUrl: './departments-details-side-menu.component.scss',
})
export class DepartmentsDetailsSideMenuComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object,
    private readonly router: Router
  ) {}

  @Input('selectedDepartment') selectedDepartment?: DepartmentI;
  private readonly destroy$ = new Subject<void>();
  sideMenuItems = SIDE_MENU_ITEMS;
  isSideMenuOpen = false;

  ngOnInit(): void {
    this.initScreenType();
    console.log(this.selectedDepartment?._id);
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url ===
      '/' + sideMenuItem.route(this.selectedDepartment?._id ?? '')
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    if (sideMenuItem.alt === 'Home') {
      return this.router.url?.trim() === '' || this.router.url === 'home';
    } else {
      return (
        this.router.url ===
        '/' + sideMenuItem.route(this.selectedDepartment?._id ?? '')
      );
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isSideMenuOpen = window.innerWidth <= 700 && window.innerWidth >= 500;
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen =
        this.document.defaultView!.innerWidth <= 700 &&
        this.document.defaultView!.innerWidth >= 500;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
